// @general/assistant - frontend surface.
//
// A module contributes to the assistant from its own views with
// registerContext(): what is on screen travels with each message, so "cancel
// this one" resolves to what the user is actually looking at.

export { useAssistantStore } from './store'
export { registerContext, setGlobalContext, collectContext } from './context'

export { default as AssistantPanel } from './components/AssistantPanel.vue'
export { default as AssistantButton } from './components/AssistantButton.vue'

// No routes: the assistant is a panel available on every screen, not a place
// you navigate to. Going somewhere to ask a question would defeat the point.
export const routes = []

export default { routes }
